import { Grid, Typography } from "@material-ui/core";
import moment from "moment";
import React, { useEffect } from "react";
import { useAppSelector } from "src/app-redux/hooks";
import { selectWareHouseItemDetails } from "src/app-redux/warehouse/wareHouseSlice";
import NoRecordFound from "src/components/NoRecordFound";
import { useStyles } from "./../style";

export interface IDrawerHistoryProps {}

export default function DrawerHistory(props: IDrawerHistoryProps) {
  const classes = useStyles();
  // Redux
  const inventoryItemDetails: any = useAppSelector(selectWareHouseItemDetails);
  useEffect(() => {
    //
  }, [inventoryItemDetails]);
  return (
    <div className={classes.drawerDetails}>
      {/* History Item  */}
      {inventoryItemDetails.itemHistory?.length !== 0 ? (
        inventoryItemDetails.itemHistory.map((item: any, index: any) => (
          <>
            <Typography className="headingHistory">
              {item.fieldName ? item.fieldName : "-"} changed by {item.entryBy ? item.entryBy : "-"}{" "}
              :
            </Typography>
            <Grid key={index} container spacing={2} className="topContainer">
              <Grid container direction="row" className="itemRow">
                <Grid md={1}></Grid>
                <Grid md={6}>
                  <Typography className="subHeading">Warehouse</Typography>
                  <Typography className="subHeadingDetails">
                    {item.warehouse ? item.warehouse : "-"}
                  </Typography>
                </Grid>
                <Grid md={5}>
                  <Typography className="subHeading">Time & Date</Typography>
                  <Typography className="subHeadingDetails">
                    {moment(new Date(item.entryDate ? item.entryDate : "-")).format(
                      "DD-MM-YYYY hh:mm A"
                    )}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container direction="row" className="itemRow">
                <Grid md={1}></Grid>
                <Grid md={6}>
                  <Typography className="subHeading">Previous Value</Typography>
                  <Typography className="subHeadingDetails">
                    {item.previousValue ? item.previousValue : "-"}
                  </Typography>
                </Grid>
                <Grid md={5}>
                  <Typography className="subHeading">New Value</Typography>
                  <Typography className="subHeadingDetails">
                    {item.newValue ? item.newValue : "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </>
        ))
      ) : (
        <div style={{ marginTop: "20px" }}>
          <NoRecordFound />
        </div>
      )}
    </div>
  );
}
